class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* Global Event Delegation for Limited Time Offer Add Buttons */
document.addEventListener('click', (event) => {
  const btn = event.target.closest('.cart-drawer__offer-add-btn');
  if (btn) {
    event.preventDefault();
    const variantId = btn.dataset.variantId;
    if (variantId && typeof window.addLimitedOfferToCart === 'function') {
      window.addLimitedOfferToCart(btn, variantId);
    }
  }
});

window.addLimitedOfferToCart = function(btn, variantId) {
  if (!variantId || btn.classList.contains('is-loading')) return;

  btn.classList.add('is-loading');
  btn.disabled = true;

  const span = btn.querySelector('span');
  const originalText = span ? span.innerText : btn.innerText;
  const loadingText = btn.dataset.loadingText || 'Adding...';
  if (span) {
    span.innerText = loadingText;
  }

  const cartDrawer = document.querySelector('cart-drawer');
  const canRender = cartDrawer
    && typeof cartDrawer.getSectionsToRender === 'function'
    && typeof cartDrawer.renderContents === 'function';

  const sections = canRender
    ? cartDrawer.getSectionsToRender().map((s) => s.id || s.section)
    : ['cart-drawer'];

  const cartDrawerItems = document.querySelector('cart-drawer-items');
  const savedScrollTop = cartDrawerItems ? cartDrawerItems.scrollTop : 0;

  const body = JSON.stringify({
    id: variantId,
    quantity: 1,
    sections: sections,
    sections_url: window.location.pathname
  });

  const cartAddUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

  fetch(`${cartAddUrl}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/javascript'
    },
    body: body
  })
  .then((response) => response.json())
  .then((response) => {
    if (response.status) {
      console.error('Error adding offer product to cart:', response.description);
      btn.classList.remove('is-loading');
      btn.disabled = false;
      if (span) span.innerText = originalText;
      return;
    }

    if (canRender) {
      if (cartDrawer.classList.contains('is-empty')) {
        cartDrawer.classList.remove('is-empty');
      }
      const inner = cartDrawer.querySelector('.drawer__inner');
      if (inner && inner.classList.contains('is-empty')) {
        inner.classList.remove('is-empty');
      }
      cartDrawer.renderContents(response);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const updatedItems = document.querySelector('cart-drawer-items');
          if (updatedItems) {
            updatedItems.scrollTop = savedScrollTop;
          }
        });
      });
    } else {
      window.location.reload();
    }
  })
  .catch((error) => {
    console.error('Error adding offer product to cart:', error);
    btn.classList.remove('is-loading');
    btn.disabled = false;
    if (span) span.innerText = originalText;
  });
};
